import { AbstractControl, ValidationErrors } from "@angular/forms"
import { ItemTypeMetadata } from "../../common-shared-module/model/dyn-form/form-metadata/item-type-metadata.enum"


export namespace sectionEditor {

    export function ItemTypeMetadataToHelpMsg(itemType: ItemTypeMetadata): string {
        switch (itemType) {
            case ItemTypeMetadata.Button:
                return "El camp de buto permet llençar una acció"
            case ItemTypeMetadata.Numeric:
                return "El camp numéric permet als usuaris introduir números"
            case ItemTypeMetadata.Text:
                return "El camp de text permet als usuaris introduir una sola línia de text."
            case ItemTypeMetadata.CheckBox:
                return "El camp de checkbox permet marca i desmarcar una opció. "
            case ItemTypeMetadata.MultiCheckBox:
                return "El camp de Mulicheckbox permet marca i desmarcar moltes opcions. "
            case ItemTypeMetadata.Custom:
                return "question_mark"
            case ItemTypeMetadata.Datepicker:
                return "El camp de text permet escullir una data del calendari"
            case ItemTypeMetadata.Html:
                return "El camp Html permet escriure text enriquit"
            case ItemTypeMetadata.Time:
                return "Hora i minuts en format 24H"
            case ItemTypeMetadata.Radio:
                return "El camp de radiobutton permet escullir una opció excluient"
            case ItemTypeMetadata.Select:
                return "El camp de selecció permet escullir una opció entre un llistat"
            case ItemTypeMetadata.TextArea:
                return "El camp de paràgraf permet als usuaris introduir varies linies"

        }
    }

    export function fieldNameValidator(control: AbstractControl): ValidationErrors | null {

        let res = /^[a-z]+[a-z0-9]*$/i

        if (!control.value) {
            return { "pattern" : "El fieldName es requerit."}
        }

        if (res.test('' + control.value) == false) {
            return { "pattern": "Ha de començar per lletra, sense espais i alfanumèric" }
        }

        return null;
    }

}